// (g) Shown while async AI grading is pending. Calm, reassuring copy.
import { motion } from 'framer-motion';

export function GradingSpinner({ label = 'Grading your answer…' }: { label?: string }) {
  return (
    <div className="flex flex-col items-center gap-3 py-10 text-center">
      <motion.span
        className="h-10 w-10 rounded-full border-4 border-slate-200 border-t-slate-700"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, ease: 'linear', duration: 0.9 }}
        aria-hidden
      />
      <p className="text-sm text-slate-600">{label}</p>
      <p className="text-xs text-slate-400">This usually takes a few seconds.</p>
    </div>
  );
}
